import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { Tabs } from 'flowbite';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import {scrollToggleFixed} from "../../utils/scrollFixedNav";

import { Accordion } from 'flowbite';
import AccordionComponent from './components/Accordion';


function activarCategoriaModular(selectedCategory) {
    document.querySelectorAll('.tab-category-modular').forEach(btn => {
        const btnCategory = btn.getAttribute('data-category-id');
        btn.classList.toggle('tab-active-category', btnCategory === selectedCategory);
    });

    const swiperContainer = document.querySelector('#products-linea-modular');
    const slides = swiperContainer.querySelectorAll('.card-products');

    slides.forEach(slide => {
        const slideCategory = slide.getAttribute('data-sub-category');
        // Cambio: solo mostrar slides que coincidan exactamente con la categoría seleccionada
        const mostrar = slideCategory === selectedCategory;
        slide.classList.toggle('card-products-hidden', !mostrar);
    });

    const swiperInstance = swiperContainer.swiper;
    if (swiperInstance) swiperInstance.update();
}

document.addEventListener('DOMContentLoaded', function ()
{

    scrollToggleFixed({
        navSelector: '#navbar',
        targetSelector: '#ventajas',
    });

    Fancybox.bind("[data-fancybox]", {
    });

    const tabsElement = document.getElementById('tabs-productos');
    const tabButtons = tabsElement.querySelectorAll('[data-tab-id]');

    const tabElements = Array.from(tabButtons).map((btn) => {
        const tabId = btn.dataset.tabId;
        return {
            id: tabId,
            triggerEl: btn,
            targetEl: document.getElementById(tabId),
        };
    });

    const options = {
        defaultTabId: tabElements[0]?.id || null,
        activeClasses:
            `tab-active-category tab-active-${tabsElement.dataset.class}`,
        inactiveClasses:
            'tab-not-active',
    };

    const instanceOptions = {
        id: 'tabs-productos',
        override: true,
    };

    const tabs = new Tabs(tabsElement, tabElements, options, instanceOptions);

    const hash = window.location.hash?.substring(1); // Remueve el "#"

    if (hash) {
        const targetTab = tabElements.find(tab => tab.id === hash);
        if (targetTab) {
            tabs.show(hash); // Activa el tab con el id del hash
        }
    }

    const swiperProceso = new Swiper('.swiper-procesos', {
        loop: true,
        slidesPerView: 2,
        autoplay: true,
        speed: 2000,
        navigation: {
            prevEl: '.swiper-button-prev-procesos',
            nextEl: '.swiper-button-next-procesos',
        },
        breakpoints: {
            320: {
                slidesPerView: 1.6,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
            1920: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
        },
    });

    const breakpoint = window.matchMedia('(min-width: 80rem)');
    const swiperInstances = new Map();

    function getDynamicSwiperConfigs() {
        const containers = document.querySelectorAll('.swiper-modelos');

        return Array.from(containers).map(container => {
            const id = container.id.replace('swiper-', '');

            return {
                element: container,
                options: {
                    loop: true,
                    navigation: {
                        nextEl: `.swiper-button-next-${id}`,
                        prevEl: `.swiper-button-prev-${id}`,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 25,
                        },
                        1024: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        1280: {
                            slidesPerView: 2,
                            spaceBetween: 25,
                        },
                        1440: {
                            slidesPerView: 3,
                            spaceBetween: 25,
                        },
                    },
                },
            };
        });
    }

    function initDynamicSwipers() {
        getDynamicSwiperConfigs().forEach(({ element, options }) => {
            if (swiperInstances.has(element)) return;

            const instance = new Swiper(element, options);
            swiperInstances.set(element, instance);
        });
    }

    function destroyAllSwipers() {
        swiperInstances.forEach((instance, el) => {
            instance.destroy(true, true);
            swiperInstances.delete(el);
        });
    }

    function handleBreakpointChange() {
        if (breakpoint.matches) {
            destroyAllSwipers();
        } else {
            initDynamicSwipers();
        }
    }

    document.querySelectorAll('.tab-category-panelizada').forEach(button => {
        button.addEventListener('click', () => {
            const selectedCategory = button.getAttribute('data-category-id');

            document.querySelectorAll('.tab-category-panelizada').forEach(btn => {
                btn.classList.remove('tab-active-category');
            });

            button.classList.add('tab-active-category');

            const swiperContainer = document.querySelector('#products-linea-panelizada');
            const slides = swiperContainer.querySelectorAll('.card-products');

            slides.forEach(slide => {
                const slideCategory = slide.getAttribute('data-sub-category');
                if (selectedCategory === 'todas' || slideCategory === selectedCategory) {
                    slide.classList.remove('card-products-hidden');
                } else {
                    slide.classList.add('card-products-hidden');
                }
            });

            const swiperInstance = swiperContainer.swiper;
            if (swiperInstance) swiperInstance.update();
        });
    });

    document.querySelectorAll('.tab-category-modular').forEach(button => {
        button.addEventListener('click', () => {
            const selectedCategory = button.getAttribute('data-category-id');

            // Elimina la clase activa de todos los botones
            document.querySelectorAll('.tab-category-modular').forEach(btn => {
                btn.classList.remove('tab-active-category');
            });

            activarCategoriaModular(selectedCategory);
        });
    });

    activarCategoriaModular('linea-para-vivir');

    const defaultButton = document.querySelector('.tab-category-modular[data-category-id="linea-para-vivir"]');
    if (defaultButton) {
        defaultButton.classList.add('tab-active-category');
    }

    breakpoint.addEventListener('change', handleBreakpointChange);
    handleBreakpointChange();

    const accContainer = document.getElementById('accordion-faq');
    if (accContainer) {
        const faqAccordion = new AccordionComponent(accContainer, {
            alwaysOpen: false,
            activeClasses: 'accordion-active',
            inactiveClasses: 'accordion-default',
        });
    }
});
